<template>
    <div class="de-rank" :style="wrapperStyle">
        <span class="index">{{rankItem.key < 10 ? `0${rankItem.key}` : rankItem.key}}</span>
        <span class="bar-wrapper" :style="barStyle">
            <span class="option">{{rankItem.option}}</span>
            <bar class="bar" :value="rankItem.percent" :color="rankItem.color" :backgroundColor="'rgba(0,145,255,0.18)'"></bar>
        </span>
        <span class="percent">{{rankItem.percent}}%</span>
        <span class="total" :style="totalStyle">{{rankItem.total | formatAmount}}</span>
    </div>
</template>

<script>
import bar from "./yBar.vue";

export default {
    name: 'de-rank',
    components: {
        bar
    },
    props: {
        rankItem: {
            type: Object,
            default: () => {
                return {
                    option: '0-5公里',
					color: 'linear-gradient(-45deg, #038CFB 0%, #102FA8 100%)',
					percent: 59.4,
					total: 3527,
					key: 1
                }
            }
        },
        barWidth: {
            type: Number,
            default: 120
        },
        margin: {
            type: Number,
            default: 12
        },
        fontObj: {
            type: Object
        }
    },
    computed: {
        wrapperStyle() {
            return this.fontObj
                ? (Object.assign({}, this.fontObj, {
                    fontSize: `${this.fontObj.fontSize}px`,
                    fontStyle: this.fontObj.fontStyle,
                    fontFamily: this.fontObj.fontFamily,
                    fontWeight: this.fontObj.fontWeight,
                    color: this.fontObj.color
                }))
                : {};
        },
        barStyle() {
            return Object.assign({}, {
                marginLeft: `${this.margin}px`,
                marginRight: `${this.margin}px`,
                width: `${this.barWidth}px`
            });
        },
        totalStyle() {
            return Object.assign({}, {
                marginLeft: `${this.margin}px`,
            });
        }
    }
}
</script>

<style lang="less" scoped>
.de-rank {
    padding-top: 10px;
    font-size: 12px;
    max-width: 400px;
    .index {
        margin-top: 10px;
        display: inline-block;
        border: 1px solid rgba(3,140,251,0.60);
        border-radius: 4px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: rgba(255,255,255,0.75);
    }
    .option {
        line-height: 30px;
    }
    .bar-wrapper {
        display: inline-block;
        vertical-align: top;
        .bar {
            margin-top: 4px;
            width: 120px;
        }
    }
    .total {
        margin-left: 12px;
    }
    .total, .percent {
        vertical-align: bottom;
    }
}
</style>